import { useState } from 'react'
import * as Yup from 'yup'
import { StoreRecaptchaToken, JSONFetcher, Button, gaEvent } from 'shared'
import { Formik, Form, Field } from 'formik'

const t = (key) => {
  return I18n.t(key, { scope: 'homepages.newsletter_box' })
}

export const SubscribeForm = (props) => {
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const submitHandler = (values, formikBag) => {
    gaEvent('engagement', 'submit subscribe_platform_newsletter_form')
    setLoading(true)
    JSONFetcher.post({
      url: props.newsletterSubscribeUrl,
      body: {
        email:            values.email,
        recaptcha_token:  values.recaptcha_token,
        target_type:      'CommunityNewsletter',
      },
      success: (response) => {
        setLoading(false)
        if (response.error) {
          formikBag.setFieldError('email', response.error)
          gaEvent('error', 'field: newsletter_email', `error: ${response.error}`, null, true)
        } else {
          setSubmitted(true)
        }
      }
    })
  }

  const error = t('form_email_error')
  const emailSchema = () => Yup.object().shape({
    email: Yup.string().email(error).max(255, error).required(error)
  })

  if (submitted) return <div className='submitted'>
    <h2>{t('optin_headline')}</h2>
    <p>{t('optin_introduction')}</p>
  </div>

  return <Formik validationSchema={emailSchema} initialValues={{ email: props.email }} onSubmit={submitHandler}>
    {formikProps => <Form>
      <StoreRecaptchaToken
        sitekey={props.recaptchaSiteKey}
        action='subscribe'
        verifyCallback={token => formikProps.setFieldValue('recaptcha_token', token)}
      />

      <div className='row'>
        <div className='form-group col-md-12'>
          <Field className='form-control form-control-lg' name='email' placeholder={t('form_email_placeholder')} type='text' />
          {formikProps.touched.email && <small>{emailErrorMsg(formikProps.errors.email)}</small>}
        </div>
        <div className='form-group col-md-12'>
          <Button className='btn-primary btn-large' smallSpinner loading={loading}>{t('form_submit_button')}</Button>
          <div>
            <small>{t('form_unsubscribe_hint')}</small>
          </div>
        </div>
      </div>
    </Form>}
  </Formik>
}

const emailErrorMsg = (error) =>
  error == 'recaptcha' ? I18n.t('errors.messages.invalid_recaptcha') : error
